<script>
import UiButton from '../ui/Button';
import deepEqual from 'deep-equal';
import { store } from '../../functions/mixins';
import * as sdk from '../../functions/sdk';
import UiCheckbox from '../ui/Checkbox';
import UiPhonePreview from '../ui/PhonePreview';
import UiSubheader from '../ui/Subheader';
import UiHeadline from '../ui/Headline';
import UiHint from '../ui/Hint';
import UiHintWrapper from '../ui/HintWrapper';
import UiModal from '../ui/Modal';
import UiLoading from '../ui/Loading';
import moment from 'moment';

export default {
    mixins: [store],
    props: {
        value: Object,
        step: Number,
        next: Function,
        send: Function,
        disableBack: Boolean,
        disableNext: Boolean,
        sendFailed: Boolean,
        showLastFrom: Number,
        isSending: Boolean,
        normalizeStep: Function,
        isDemoMode: Boolean,
        phonePreviewMessage: [Object, Array],
        hint: String,
        disableToogleButton: Boolean,
        previewData: Object,
    },
    components: {
        UiButton,
        UiCheckbox,
        UiPhonePreview,
        UiSubheader,
        UiHeadline,
        UiHint,
        UiModal,
        UiLoading,
        UiHintWrapper,
    },
    data: () => ({
        expanded: false,
        sending: false,
        data: null,
        confirmModal: false,
        confirmModalLoading: false,
        topicList: [],
        welcomeModalVisible: false,
        welcomeLoading: false,
        welcomeFailed: false,
        welcomeSaved: false,
        disableAllGroups: false,
        previewTab: 'iphone',
        extraPushEmbedded: false,
        channelIds: [],
        channelIdsText: '',
    }),
    computed: {
        isSendNowChecked() {
            return this.data.time.sendNow;
        },
        yearsValues() {
            const y = moment().year();
            return [y, y + 1, y + 2];
        },
        monthsValues() {
            return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        },
        daysValues() {
            const year = parseInt(this.data.time.year);
            const month = parseInt(this.data.time.month);
            const daysInMonth = moment().year(year).month(month - 1).daysInMonth();
            let result = [];
            for (let i = 0; i < daysInMonth; i++) {
                result.push(i + 1);
            }
            return result;
        },
        demoURL() {
            const bubble = this.data.bubble;
            return bubble ? `https://mockup.pressenger.com/?gid=${bubble.groupId}&bfn=${bubble.fileName}` : '';
        },
        isSendEnabled() {
            if (this.isDemoMode) {
                return false;
            }
            if (this.data.sendingMethod === 'topic' && this.data.method.topic.length === 0) {
                return false;
            }
            if (this.data.sendingMethod === 'custom' && (!this.data.method.recipients && !this.data.recipientList)) {
                return false;
            }
            return true;
        },
        sendButtonText() {
            switch(this.data.sendingMethod) {
                case 'generate':
                    return this.$t('bottomSheet.sendForGenerate');
                case '3rdparty':
                    return this.$t('bottomSheet.sendFor3rdParty');
                default:
                    return this.$t('bottomSheet.send');
            }
        },
        helpDialogText() {
            let text = this.$t('bottomSheet.titleHint');
            if (this.userInfo.canSendToAll) {
                text += this.$t('bottomSheet.titleHintPlusSendToAll');
            }
            if (this.userInfo.uploadRecipients) {
                text += this.$t('bottomSheet.titleHintPlusUploadRecipients');
            }
            return text;
        },
    },
    created() {
        this.data = Object.assign({}, this.value);
        const topicListRaw = localStorage.getItem('topicList');
        const channelIdsRaw = localStorage.getItem('channelIds');
        try {
            this.topicList = JSON.parse(topicListRaw);
        } catch (e) {}
        try {
            this.channelIds = JSON.parse(channelIdsRaw);
        } catch (e) {}
        if (!Array.isArray(this.topicList)) {
            this.topicList = [];
        }
        if (!Array.isArray(this.channelIds)) {
            this.channelIds = [];
        }
        this.topicList = [... new Set(this.topicList)];
        this.channelIds = [... new Set(this.channelIds)];
        if (!this.previewData.iosExtNotification) {
            if (!this.previewData.iosAppleWatch) {
                this.previewTab === 'android';
            } else {
                this.previewTab === 'applewatch';
            }
        }
    },
    methods: {
        setExpanded(val) {
            this.expanded = val;
            this.disableAllGroups = false;
            if (!val) {
                this.normalizeStep(-1);
            } else {
                if (this.isPushwize) {
                    this.setSendingMethod('generate');
                    this.disableAllGroups = true;
                    setTimeout(() => {
                        this.executeSend();
                    });
                } else if (this.userInfo.extraPushOnly) {
                    this.setSendingMethod('3rdparty');
                    setTimeout(() => {
                        this.disableAllGroups = true;
                        this.executeSend();
                    });
                }
            }
        },
        setSendNow(value) {
            this.data.time.sendNow = value;
        },
        setSendToAll(value) {
            this.data.method.sendToAll = value;
        },
        setSendingMethod(method) {
            this.data.sendingMethod = method;
        },
        importCVS(e) {
            if (e.target.files[0]) {
                const fr = new FileReader;
                fr.onload = (e) => {
                    this.data.method.recipients = e.target.result;
                };
                fr.readAsText(e.target.files[0]);
            }
        },
        pn(num, minLen) {
            let str = num.toString();
            if (!minLen || str.length >= minLen) {
                return str;
            }
            let prepend = new Array(minLen - str.length + 1).join('0');
            return prepend + str;
        },
        setConfirmModal(visible, loading = false) {
            this.confirmModal = visible;
            this.confirmModalLoading = loading;
        },
        executeSend() {
            this.saveSaveChannelIds();
            this.saveTopics();
            this.setConfirmModal(false);
            this.send();
        },
        prepareSend() {
            this.setConfirmModal(true, false);
        },
        setDisableBubble(value) {
            this.data.bubbleDisabled = value;
        },
        saveTopics() {
            if (this.data.sendingMethod === 'topic') {
                if (!this.topicList.find(i => i === this.data.method.topic)) {
                    this.topicList.push(this.data.method.topic)
                }
                localStorage.setItem('topicList', JSON.stringify(this.topicList));
            }
        },
        saveSaveChannelIds() {
            if (this.userInfo.enableNotiChannels) {
                if (!this.channelIds.find(i => i === this.data.channelId)) {
                    this.channelIds.push(this.data.channelId)
                }
                localStorage.setItem('channelIds', JSON.stringify(this.channelIds));
            }
        },
        saveWelcomeMessage() {
            this.welcomeModalVisible = true;
            this.welcomeLoading = true;
            this.welcomeSaved = false;
            this.welcomeFailed = false;
            this.send(true).then(() => {
                this.welcomeSaved = true;
            }).catch(() => {
                this.welcomeFailed = true;
            }).finally(() => {
                this.welcomeLoading = false;
            });
        },
        closeWelcomeDialog() {
            window.confirmBeforeRouteChange = false;
            this.welcomeModalVisible = false;
            this.$router.push({name: 'settings', hash: '#welcome-message'});
        },
        onCloseClicked() {
            if (this.data.extraPushIframe) {
                window.confirmBeforeRouteChange = false;
                window.location.reload();
            } else {
                this.setExpanded(false);
            }
        },
    },
    watch: {
        value: {
            deep: true,
            handler(nextVal) {
                if (!deepEqual(nextVal, this.data)) {
                    this.data = Object.assign({}, nextVal);
                }
            }
        },
        data: {
            deep: true,
            handler: function(nextVal) {
                if (!deepEqual(nextVal, this.value)) {
                    this.$emit('input', Object.assign({}, nextVal));
                }
            }
        },
        step(nextVal) {
            if (nextVal === 1) {
                this.setConfirmModal(false);
                this.setExpanded(false);
            }
        },
    },
}
</script>

<template>
    <div :class="['BottomSheet', {Peek: step > 1, Expanded: expanded, BottomSheetFull: isPushwize || isInflugamers}]">
        <ui-modal :visible="welcomeModalVisible">
            <ui-loading v-if="welcomeLoading" />
            <template v-else>
                <p v-if="welcomeSaved">{{ $t('bottomSheet.welcomeSaved') }}</p>
                <p v-if="welcomeFailed">{{ $t('bottomSheet.welcomeFailed') }}</p>
                <div class="FlexRow JustifyEnd">
                    <ui-button @click.native="closeWelcomeDialog()" class="primary white">
                        {{ $t('bottomSheet.welcomeClose') }}
                    </ui-button>
                </div>
            </template>
        </ui-modal>
        <div :class="['Navigation', {HideToggle: step < showLastFrom, HideNext: step === 10}]">
            <div class="Back">
                <ui-button @click.native="next(-1)" :disabled="disableBack" class="clear">
                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="8" height="14" viewBox="0 0 8 14" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.287 7.694l6.04 6.022a.987.987 0 001.392 0 .979.979 0 000-1.387L2.374 7l5.345-5.328a.979.979 0 000-1.387.987.987 0 00-1.392 0L.287 6.307a.983.983 0 000 1.387z"/></svg>
                    {{ $t('bottomSheet.back') }}
                </ui-button>
            </div>
            <!--
            <div class="InfoMessage" v-if="data.hint">
                <span v-html="data.hint"></span>
            </div>
            -->
            <div class="HintContainer" v-if="hint">
                <ui-hint-wrapper :text="hint" showInfoSign />
            </div>
            <div class="Toggle">
                <template v-if="step === 9 && !isEditorAccount && !userInfo.disableWelcome && !isPushwize && !isInflugamers && !data?.isModNews">
                    <ui-button @click.native="saveWelcomeMessage()" :disabled="disableNext" class="white">
                        {{ $t('bottomSheet.saveWelcome') }}
                    </ui-button>
                    &nbsp;
                </template>
                <ui-button @click.native="setExpanded(true)" :disabled="disableNext" class="white" v-if="!disableToogleButton">
                    {{ $t('bottomSheet.toggle') }}
                </ui-button>
            </div>
            <div class="Next">
                <ui-button @click.native="next()" :disabled="disableNext" class="clear">
                    {{ $t('bottomSheet.next') }}
                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="8.03" height="14" viewBox="0 0 8.03 14" v-bind:svg-inline="''" v-bind:class="'ml-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M7.741 6.305L1.678.283a.993.993 0 00-1.397 0 .977.977 0 000 1.387l5.366 5.328-5.366 5.329a.977.977 0 000 1.387.993.993 0 001.397 0l6.063-6.022a.975.975 0 000-1.387z"/></svg>
                </ui-button>
            </div>
        </div>
        <div class="CloseWrapper">
            <ui-button @click.native="onCloseClicked()" class="clear">
                <span class="mdi mdi-close" style="font-size: 32px"></span>
            </ui-button>
        </div>
        <div :class="['Content', {Loading: isSending}]">
            <div class="LoadingOverlay">
                <ui-loading />
            </div>
            <div class="ContentRow">
                <div class="PreviewPanel">
                    <!--
                    <ui-subheader class="Simple">{{ $t('bottomSheet.previewTitle') }}</ui-subheader>
                    -->
                    <div class="PhoneWrapper">
                        <div class="TabsDevices">
                            <button @click="previewTab = 'iphone'" v-if="previewData.iosExtNotification" :class="{Active: previewTab === 'iphone'}">
                                <img src="/static/img/toolbox/icon_iphone.png" />
                            </button>
                            <button @click="previewTab = 'applewatch'" v-if="previewData.iosAppleWatch" :class="{Active: previewTab === 'applewatch'}">
                                <img src="/static/img/toolbox/icon_applewatch.png" />
                            </button>
                            <button @click="previewTab = 'android'" v-if="previewData.androidBanner" :class="{Active: previewTab === 'android'}">
                                <img src="/static/img/toolbox/icon_android.png" />
                            </button>
                        </div>
                        <template v-if="previewTab === 'iphone'">
                            <ui-phone-preview
                                v-if="expanded && previewData.iosExtNotification"
                                :view="'V_IOS_EXTENDED_NOTIFICATION'"
                                :device="'D_IPHONE'"
                                v-bind="previewData"
                                :maxWidth="180"
                            />
                        </template>
                        <template v-if="previewTab === 'applewatch'">
                            <ui-phone-preview
                                v-if="expanded && previewData.iosAppleWatch"
                                :view="'V_IOS_APPLE_WATCH'"
                                :device="'D_APPLEWATCH'"
                                v-bind="previewData"
                                :maxWidth="180"
                            />
                        </template>
                        <template v-if="previewTab === 'android'">
                            <ui-phone-preview
                                v-if="expanded && previewData.androidBanner"
                                :view="'V_ANDROID_BANNER'"
                                :device="'D_ANDROID'"
                                v-bind="previewData"
                                :maxWidth="180"
                            />
                        </template>
                    </div>
                </div>
                <div :class="['SettingsPanel', {Error: sendFailed}]" v-if="!data.extraPushIframe">
                    <ui-headline class="mt-0 mb-3" v-if="isDemoMode">
                        {{ $t('bottomSheet.demoTitle') }}
                    </ui-headline>
                    <ui-headline class="mt-0 mb-3" v-else>
                        {{ $t('bottomSheet.title') }}
                        <!--
                        <ui-hint class="Abs Full" style="top: 20px; right: -50px">
                            <div v-html="helpDialogText" />
                        </ui-hint>
                        -->
                    </ui-headline>
                    <div class="Group" v-if="isDemoMode">
                        <a :href="demoURL" target="_blank" class="DemoURL">{{ demoURL }}</a>
                    </div>
                    <template v-else>
                        <div :class="['Group', {GroupDisabled: data.recipientList || disableAllGroups}]">
                            <ui-subheader class="mt-0">{{ $t('bottomSheet.timeTitle') }}</ui-subheader>
                            <div class="CheckboxGroup">
                                <ui-checkbox
                                    :checked="isSendNowChecked"
                                    @click.native="!data.recipientList && setSendNow(true)"
                                    readonly
                                ><span v-html="$t('bottomSheet.sendNow')"/></ui-checkbox>
                                <ui-checkbox
                                    :checked="!isSendNowChecked"
                                    @click.native="!data.recipientList && setSendNow(false)"
                                    readonly
                                ><span v-html="$t('bottomSheet.sendLater')"/></ui-checkbox>
                            </div>
                            <div :class="{Collapse: true, In: isSendNowChecked}">
                                <div class="DateTime">
                                    <div class="Date">
                                        <select v-model="data.time.year">
                                            <option v-for="i in yearsValues" :key="i">{{ pn(i) }}</option>
                                        </select>
                                        <select v-model="data.time.month">
                                            <option v-for="i in monthsValues" :key="i"> {{ pn(i, 2) }} </option>
                                        </select>
                                        <select v-model="data.time.day">
                                            <option v-for="i in daysValues" :key="i">{{ pn(i, 2) }} </option>
                                        </select>
                                    </div>
                                    <div class="Time">
                                        <select v-model="data.time.hours">
                                            <option v-for="i in 24" :key="i">{{ pn(i - 1, 2) }}</option>
                                        </select>
                                        <span>:</span>
                                        <select v-model="data.time.minutes">
                                            <option>00</option>
                                            <option>15</option>
                                            <option>30</option>
                                            <option>45</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div :class="['Group', {GroupDisabled: data.recipientList || disableAllGroups}]">
                            <ui-subheader class="mt-0">{{ $t('bottomSheet.methodTitle') }}</ui-subheader>
                            <div class="CheckboxGroup">
                                <ui-checkbox
                                    v-if="userInfo.canSendToAll"
                                    :checked="data.sendingMethod === 'all'"
                                    @click.native="!data.recipientList && setSendingMethod('all')"
                                    readonly
                                ><span v-html="$t('bottomSheet.sendToAll')" /></ui-checkbox>
                                <ui-checkbox
                                    v-if="userInfo.uploadRecipients"
                                    :checked="data.sendingMethod === 'custom'"
                                    @click.native="!data.recipientList && setSendingMethod('custom')"
                                    readonly
                                ><span v-html="$t('bottomSheet.sendToList')" /></ui-checkbox>
                                <ui-checkbox
                                    :checked="data.sendingMethod === 'topic'"
                                    @click.native="!data.recipientList && setSendingMethod('topic')"
                                    readonly
                                ><span v-html="$t('bottomSheet.topicSending')" /></ui-checkbox>
                                <template v-if="userInfo.extraPush || isPushwize">
                                    <ui-checkbox
                                        :checked="data.sendingMethod === 'generate'"
                                        @click.native="!data.recipientList && setSendingMethod('generate')"
                                        readonly
                                    ><span v-html="$t('bottomSheet.methodGenerate')"/></ui-checkbox>
                                    <ui-checkbox
                                        :checked="data.sendingMethod === '3rdparty'"
                                        @click.native="!data.recipientList && setSendingMethod('3rdparty')"
                                        readonly
                                        v-if="userInfo.extraPushUrl"
                                    ><span v-html="$t('bottomSheet.method3rdParty')"/></ui-checkbox>
                                </template>
                            </div>
                            <div :class="{Collapse: true, In: data.sendingMethod !== 'custom'}">
                                <div class="UploadCSV">
                                    <input :value="data.method.recipients" readonly :placeholder="$t('bottomSheet.chooseFile')" />
                                    <button @click="$refs.uploadCSV.click()">{{ $t('bottomSheet.browse') }}</button>
                                    <input ref="uploadCSV" type="file" style="display: none" @change="importCVS" accept=".csv,.txt" />
                                </div>
                            </div>
                            <div :class="{Collapse: true, In: data.sendingMethod !== 'topic'}">
                                <div class="UploadCSV" v-if="userInfo.topicList && userInfo.topicList.split('\n').length > 0">
                                    <select v-model.trim="data.method.topic">
                                        <option value="">---</option>
                                        <option v-for="i in userInfo.topicList.split('\n')" :key="i" :value="i">{{ i }}</option>
                                    </select>
                                </div>
                                <div class="UploadCSV" v-else>
                                    <input v-model.trim="data.method.topic" :placeholder="$t('bottomSheet.topicPlaceholder')" list="topic-list" />
                                    <datalist id="topic-list">
                                        <option v-for="(t, i) in topicList" :key="i">{{ t }}</option>
                                    </datalist>
                                </div>
                            </div>
                            <div v-if="userInfo.enableNotiChannels" style="margin-top: 5px">
                                <div class="UploadCSV">
                                    <input v-model.trim="data.channelId" :placeholder="$t('bottomSheet.channelIds')" list="channelIds-list" />
                                    <datalist id="channelIds-list">
                                        <option v-for="(id, i) in channelIds" :key="i">{{ id }}</option>
                                    </datalist>
                                </div>
                            </div>
                        </div>
                        <!--
                        <div class="Group">
                            <ui-subheader class="mt-0">{{ $t('bottomSheet.disableBubble') }}</ui-subheader>
                            <div class="CheckboxGroup">
                                <ui-checkbox
                                    :checked="!data.bubbleDisabled"
                                    @click.native="setDisableBubble(false)"
                                    readonly
                                ><span v-html="$t('bottomSheet.no')" /></ui-checkbox>
                                <ui-checkbox
                                    :checked="data.bubbleDisabled"
                                    @click.native="setDisableBubble(true)"
                                    readonly
                                ><span v-html="$t('bottomSheet.yes')" /></ui-checkbox>
                            </div>
                        </div>
                        -->
                    </template>
                    <div class="Actions">
                        <ui-button @click.native="setExpanded(false)" class="icon white secondary semibig">
                            <span class="mdi mdi-chevron-left"></span>
                        </ui-button>
                        <ui-button @click.native="prepareSend()" class="white semibig" :disabled="!isSendEnabled">
                            {{ sendButtonText }}
                        </ui-button>
                        <ui-modal :visible="confirmModal">
                            <ui-loading v-if="confirmModalLoading" />
                            <template v-else>
                                <p>
                                    {{ isSendNowChecked ? $t('bottomSheet.confirmMessage') : $t('bottomSheet.confirmMessageAlt') }}
                                </p>
                                <div class="FlexRow JustifyEnd">
                                    <ui-button @click.native="setConfirmModal(false)" class="white primary">
                                        {{ isSendNowChecked ? $t('bottomSheet.confirmNo') : $t('bottomSheet.confirmNoAlt') }}
                                    </ui-button>
                                    <ui-button @click.native="executeSend()" class="white primary ml-1">
                                        {{ isSendNowChecked ? $t('bottomSheet.confirmYes') : $t('bottomSheet.confirmYesAlt') }}
                                    </ui-button>
                                </div>
                            </template>
                        </ui-modal>
                    </div>
                </div>
                <div class="ExtraPushEmbedded" v-if="data.extraPushIframe" :style="{height: userInfo.pushWebviewHeight || 'auto', width: '400px' }">
                    <iframe :src="data.extraPushIframe"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.BottomSheet
    position fixed
    height calc(100% + 100px)
    bottom calc(-100% - 100px)
    right 0
    left 100px
    z-index 20
    background #fff
    box-shadow 0 0 4px rgba(0,0,0,.1)
    transition: .3s all
    &.BottomSheetFull
        left 0
    .Navigation
        position relative
        height 100px
        display flex
        align-items center
        overflow hidden
        transition .3s all
        .Back, .Next
            position absolute
            padding 0
            transition .3s all
            .mr-3, .ml-3
                transition .3s all
            &:before, &:after
                content ''
                position absolute
                transition .3s all
            &:before
                width 1px
                background $cBorder
                top -100px
                bottom -100px
            &:after
                width 3px
                background $cAccent
                top 5px
                bottom 5px
            &:hover:after
                width 7px
        .Next
            right 0
        .Back:before
            right 0
        .Back:after
            right -1px
        .Next:before
            left 0
        .Next:after
            left -1px
        .Back:hover
            &:after
                right -3px
            .mr-3
                transform translate(-20px,0)
        .Next:hover
            &:after
                left -3px
            .ml-3
                transform translate(20px,0)
        .Toggle
            transition .3s all
            position absolute
            right 50%
            transform: translate(50%,0) scale(1,1);
        &.HideNext
            .Toggle
                transform: translate(0,0) scale(1,1);
                right 50px
            .Next
                transform: scale(0,0);
        &.HideToggle
            .Toggle
                transform: translate(50%,0) scale(0,0);
        .InfoMessage
            position absolute
            right 50%
            transform translate(50%,0)
            padding 16px
            border 2px solid $cAccent
            text-align center
        .HintContainer
            position absolute
            right 50%
            transform translate(50%,0)
    .CloseWrapper
        display flex
        align-items center
        justify-content flex-end
    .Content
        max-width 100%
        width 800px
        box-sizing content-box
        margin 0 auto
        padding 20px
        display flex
        flex-direction column
        transform translate(-28px,0)
        .LoadingOverlay
            position absolute
            top 0
            bottom 0
            left 0
            right 0
            background rgba(255,255,255,1)
            transform translate(0,100%)
            transition .3s all
            display flex
            align-items center
            justify-content center
            z-index 999
            opacity 0
        &.Loading
            .LoadingOverlay
                transform translate(0,0)
                opacity 1
        .ContentRow
            display flex
        .PreviewPanel
            overflow hidden
            width 50%
            display flex
            flex-direction column
            justify-content center
            align-items center
            .PhoneWrapper
                overflow visible
                display flex
                justify-content center
                align-items center
                position relative
                .TabsDevices
                    position absolute
                    top 50%
                    right calc(100% + 10px)
                    transform translate(0, -50%)
                    display flex
                    flex-direction column
                    button
                        outline 0
                        border none
                        background none
                        opacity .5
                        transition .3s all
                        cursor pointer
                        &:hover, &.Active
                            opacity 1
                        img
                            width 32px
                            height auto
        .SettingsPanel
            width 50%
            flex 1 1 auto
            .Group
                position relative
                width 350px
                border 1px solid $cBorder
                padding 20px
                transition .3s all
                .DemoURL
                    text-decoration none
                    color #252449
                    &:hover
                        text-decoration underline
                &:nth-child(2)
                    //border-bottom none
                .CheckboxGroup
                    display flex
                    justify-content space-between
                    align-items center
                    flex-wrap wrap
                    .Checkbox
                        width 50%
                        margin-bottom 20px
                &.GroupDisabled:after
                    content ""
                    position absolute
                    top 0
                    right 0
                    bottom 0
                    left 0
                    background rgba(255,255,255,.8)
             .DateTime
                    display flex
                    justify-content space-between
                    align-items center
                    .Date
                        display flex
                        align-items center
                    .Time
                        display flex
                        align-items center
                    select
                        position relative
                        border 1px solid $cBorder
                        color #999
                        padding 5px
                        min-width 0
                        appearance none
                        margin-right 5px
                        &:last-child
                            margin-right 0
                    span
                        margin-right 5px
            &.Error .Group
                border-color $cError
            .UploadCSV
                display flex
                justify-content space-between
                align-items center
                button, input, select
                    border 1px solid $cBorder
                    padding 5px 15px
                    background #fff
                    font-size 12px
                input, select
                    color $cPrimary
                    flex 1 1 auto
                button
                    color $cPrimary
                    font-weight 700
                    text-transform uppercase
                    border-left none
            .Collapse
                max-height 100px
                transition .3s all
                overflow hidden
                &.In
                    max-height 0
        .ExtraPushEmbedded
            display: flex
            justify-content: stretch
            align-items: stretch
            iframe
                width 100%
                height 100%
                border none
        .Actions
            display flex
            flex-direction row
            justify-content space-between
            align-items center
            margin-top 50px
            align-self flex-end
    &.Peek
        bottom calc(-100%)
    &.Expanded
        bottom 0
        left 0

</style>
